namespace App {
    export class Comunicacao {
        public static readonly CANAL_PRE_CODIGO_CONFIRMACAO = "message-";
        public static readonly CANAL_RECEIVE = "message_fse_cliente";
        public static readonly CANAL_REQUEST = "message-fsb-server";
        public static readonly RECEBER_CONFIRMACAO_CONECTADO = 0;
        public static readonly RECEBER_PEDIR_CODIGO_VALIDACAO = 1;
        public static readonly REQUEST_SALVAR_CONFIGURACOES = 2;
        public static readonly REQUEST_INICIAR_BOT = 3;
        public static readonly REQUEST_INICIAR_CONTA = 4;
        public static readonly REQUEST_TESTAR_BOT = 5;
        public static readonly REQUEST_PARAR_BOT = 6;
        public static readonly REQUEST_PARAR_CONTA = 7;
        public static readonly REQUEST_OBTER_CONFIG_CONTAS = 8;
        public static readonly REQUEST_PAUSAR_CONTA = 9;
        public static readonly RECEBER_ATUALIZAR_CONTA = 10;
        public static readonly RECEBER_ATUALIZACAO_STATUS = 11;
        public static readonly RECEBER_CONSOLIDADOS_DIA = 12;
        public static readonly REQUEST_CODE_STATUS_RESPONSE_MOCK = 13;
        public static readonly RECEBER_EVENTO = 14;
        public static readonly RECEBER_LOG = 15;
        public static readonly REQUEST_OBTER_LOGS = 16;
        public static readonly RECEBER_STATUS_EXECUCAO = 17;
        public static readonly RECEBER_ALERTA_AUTENTICACAO_FALHOU = 18;
        public static readonly RECEBER_ALERTA_AUTENTICACAO_CONCLUIDA = 19;
        public static readonly REQUEST_SALVAR_CONFIGURACAO_GERAL = 20;
        public socket: any;

        constructor(socket: any) {
            this.socket = socket;
        }

        /**
         * Comunicação socket com servidor
         * param id Id do tipo de comunicação da Classe Comunicação
         * param request any - dados para enviar na comunicação
         * param callback any - metodo executar apos resposta do servidor
         */
        public enviar(acao: number | string, request: any, callback: any = null): void {
            this.socket.emit(Comunicacao.CANAL_REQUEST, acao, request, (response: IRespostaMensagem) => {
                if (callback) {
                    callback(response);
                }
            });
        }
        public eniviarCodigoConfirmacao(email: string, code: number, callback: any = null): void {
            this.socket.emit(Comunicacao.CANAL_PRE_CODIGO_CONFIRMACAO + email, { code: code }, (response: IRespostaMensagem) => {
                console.log(response.status, response.result);
                if (callback) {
                    callback(response);
                }
            });
        }
    }
}
